// src/components/FeaturedCategories.js
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import { getHomepageFeaturedCategories } from "../services/homepage.api";

function FeaturedCategories() {
  const navigate = useNavigate();
  const { lang } = useContext(LanguageContext);
  const [cards, setCards] = useState([]);

  const TEXT = {
    EN: { explore: "SHOP NOW" },
    AR: { explore: "تسوقي الآن" },
  };

  useEffect(() => {
    getHomepageFeaturedCategories().then(setCards).catch(() => {});
  }, []);

  return (
    <div className="w-full grid grid-cols-2 gap-2 px-0 mt-1 mb-0 overflow-x-hidden">
      {cards.map((card, i) => (
        <button
          key={card.id}
          onClick={() =>
navigate(`/products?category=${card.category_slug}`, {
  state: { from: "home" },
})


          }
          className="
            relative overflow-hidden bg-gray-200 group
            h-56 md:h-auto
            transition-all duration-300
            hover:shadow-[0_8px_30px_rgba(0,0,0,0.28)]
            hover:-translate-y-1
            card-3d animate-fadeInSeason
            rounded-none
          "
          style={{ animationDelay: `${i * 0.15}s` }}
        >
          <img
            src={card.mobile_image}
            alt={lang === "EN" ? card.title_en : card.title_ar}
            className="
              md:hidden 
              w-full h-full object-cover
              transition-transform duration-[900ms]
              group-hover:scale-110
            "
          />

          <img
            src={card.desktop_image}
            alt={lang === "EN" ? card.title_en : card.title_ar}
            className="
              hidden md:block 
              w-full 
              h-56 md:h-[380px] lg:h-[480px] xl:h-[560px] 
              object-cover 
              transition-transform duration-[900ms]
              group-hover:scale-110
            "
          />

          <div
            className="
              absolute inset-0 bg-black/30 
              opacity-0 group-hover:opacity-60 
              transition-opacity duration-300
            "
          ></div>

          <div
            className="
              absolute inset-0 pointer-events-none 
              opacity-0 group-hover:opacity-20 
              transition-all duration-700
              bg-gradient-to-r from-transparent via-white/40 to-transparent
              translate-x-[-150%] group-hover:translate-x-[150%]
            "
          ></div>

          <div
            className="
              absolute bottom-3 md:bottom-5 
              w-full flex flex-col items-center text-center 
              transition-all duration-300 
              group-hover:bottom-6
              opacity-0 animate-textRevealSeason
            "
          >
            <p
              className="
                text-xs md:text-base lg:text-lg 
                font-semibold tracking-wide text-white 
                drop-shadow-md
              "
              dir={lang === "AR" ? "rtl" : "ltr"}
            >
              {lang === "EN" ? card.title_en : card.title_ar}
            </p>

            <span
              className="
                underline text-white 
                text-[10px] md:text-sm lg:text-base 
                drop-shadow-md tracking-wide
              "
              dir={lang === "AR" ? "rtl" : "ltr"}
            >
              {TEXT[lang]?.explore}
            </span>
          </div>
        </button>
      ))}
    </div>
  );
}

export default FeaturedCategories;
